import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DishServices } from "../../../../dish/services";
import { Globals } from "../../../../../globals";
import { CartaServices } from '../../../services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateDishPage } from '../../../../components/popups/create-dish/create-dish';
import { AnalyticsServices } from '../../../../services/analyticsServices';
/**
 * Generated class for the MenuPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-carta-partial-dish-prod-select',
    templateUrl: 'carta-partial-dish-prod-select.html',
})
export class CartaPartialDishProdSelectPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public cartaServices: CartaServices,
        public translate: TranslateService,
        public modalCtrl: ModalController,
        public analyticsServices: AnalyticsServices) {

        this.getElements();
    }

    async getElements() {
        await this.cartaServices.getPagesDishesProducts(0);
    }

    async insert(element) {
        //Funcion que añadir al array de platos seleccionados para el menu
        if (!this.check(element.UID)) { //Buscamos si el plato ya esta anadido
            this.analyticsServices.trackingExp('entrar plato a carta', this.globals.tracking_exp['insert_element_menu'], '');
            var _array = Array();

            if (element.type == 'dish') {
                _array.push(element.UID); //UID
                _array.push(this.cartaServices.carta_dish_prod_array_tmp.length + 1); //Order
                _array.push('dish');
                if (element.name_es != undefined && element.name_es != '') {
                    _array.push(element.name_es);
                } else {
                    _array.push(this.globals.nameLangSelectDish(element));
                }
                if (element.name_ca != undefined && element.name_ca != '') {
                    _array.push(element.name_ca);
                } else {
                    _array.push(this.globals.nameLangSelectDish(element));
                }
                if (element.name_en != undefined && element.name_en != '') {
                    _array.push(element.name_en);
                } else {
                    _array.push(this.globals.nameLangSelectDish(element));
                }
                if (element.name_de != undefined && element.name_de != '') {
                    _array.push(element.name_de);
                } else {
                    _array.push(this.globals.nameLangSelectDish(element));
                }
                if (element.name_fr != undefined && element.name_fr != '') {
                    _array.push(element.name_fr);
                } else {
                    _array.push(this.globals.nameLangSelectDish(element));
                }
                if (element.name_it != undefined && element.name_it != '') {
                    _array.push(element.name_it);
                } else {
                    _array.push(this.globals.nameLangSelectDish(element));
                }
                _array.push(element.allergens);
                _array.push(element.price);
                _array.push(element.price_half);
                _array.push(element.price_tapa);
                _array.push(element.foodcost_static / element.foodcost_parts);
                if (element.image != undefined) {
                    _array.push(element.image);
                } else {
                    _array.push('');
                }

                if (element.description_es != undefined && element.description_es != '') {
                    _array.push(element.description_es);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_ca != undefined && element.description_ca != '') {
                    _array.push(element.description_ca);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_en != undefined && element.description_en != '') {
                    _array.push(element.description_en);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_de != undefined && element.description_de != '') {
                    _array.push(element.description_de);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_fr != undefined && element.description_fr != '') {
                    _array.push(element.description_fr);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_it != undefined && element.description_it != '') {
                    _array.push(element.description_it);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.tags != undefined) {
                    _array.push(element.tags);
                } else {
                    _array.push([]);
                }
                if (element.price_takeaway != undefined) {
                    _array.push(element.price_takeaway);
                } else {
                    _array.push('');
                }
                if (element.tk_active == undefined || element.tk_active) {
                    _array.push(true);
                } else {
                    _array.push(false);
                }
                if (element.featured) {
                    _array.push(true);
                } else {
                    _array.push(false);
                }
                if (element.tk_pickup_day) {
                    _array.push(element.tk_pickup_day);
                } else {
                    _array.push('');
                }
                if (element.tax) {
                    _array.push(element.tax);
                } else {
                    _array.push(10);
                }

                let toast = this.toastCtrl.create({
                    message: this.translate.instant('general-plato') + ' ' + this.globals.nameLangSelectDish(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();

            } else if (element.type == 'product') {
                _array.push(element.UID);
                _array.push(this.cartaServices.carta_dish_prod_array_tmp.length + 1); //Order
                _array.push('product');
                if (element.name != undefined && element.name != '') {
                    _array.push(element.name);
                } else {
                    _array.push(this.globals.nameLangSelectProduct(element));
                }
                if (element.name_ca != undefined && element.name_ca != '') {
                    _array.push(element.name_ca);
                } else {
                    _array.push(this.globals.nameLangSelectProduct(element));
                }
                if (element.name_en != undefined && element.name_en != '') {
                    _array.push(element.name_en);
                } else {
                    _array.push(this.globals.nameLangSelectProduct(element));
                }
                if (element.name_de != undefined && element.name_de != '') {
                    _array.push(element.name_de);
                } else {
                    _array.push(this.globals.nameLangSelectProduct(element));
                }
                if (element.name_fr != undefined && element.name_fr != '') {
                    _array.push(element.name_fr);
                } else {
                    _array.push(this.globals.nameLangSelectProduct(element));
                }
                if (element.name_it != undefined && element.name_it != '') {
                    _array.push(element.name_it);
                } else {
                    _array.push(this.globals.nameLangSelectProduct(element));
                }
                _array.push(element.allergens);
                _array.push(element.pvp);
                if (element.pvp2 != undefined) {
                    _array.push(element.pvp2);
                } else {
                    _array.push('');
                }
                if (element.pvp3 != undefined) {
                    _array.push(element.pvp3);
                } else {
                    _array.push('');
                }
                _array.push(element.price_static);
                if (element.image != undefined) {
                    _array.push(element.image);
                } else {
                    _array.push('');
                }
                if (element.description_es != undefined && element.description_es != '') {
                    _array.push(element.description_es);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_ca != undefined && element.description_ca != '') {
                    _array.push(element.description_ca);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_en != undefined && element.description_en != '') {
                    _array.push(element.description_en);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_de != undefined && element.description_de != '') {
                    _array.push(element.description_de);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_fr != undefined && element.description_fr != '') {
                    _array.push(element.description_fr);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.description_it != undefined && element.description_it != '') {
                    _array.push(element.description_it);
                } else {
                    _array.push(this.globals.descriptionLangSelectArticle(element));
                }
                if (element.tags != undefined) {
                    _array.push(element.tags);
                } else {
                    _array.push([]);
                }
                if (element.pvp_takeaway != undefined) {
                    _array.push(element.pvp_takeaway);
                } else {
                    _array.push(0);
                }
                if (element.tk_active == undefined || element.tk_active) {
                    _array.push(true);
                } else {
                    _array.push(false);
                }
                if (element.featured) {
                    _array.push(true);
                } else {
                    _array.push(false);
                }
                if (element.tk_pickup_day) {
                    _array.push(element.tk_pickup_day);
                } else {
                    _array.push('');
                }
                if (element.tax) {
                    _array.push(element.tax);
                } else {
                    _array.push(10);
                }

                let toast = this.toastCtrl.create({
                    message: this.translate.instant('general-producto') + ' ' + this.globals.nameLangSelectProduct(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            } else {
                _array.push(element.UID);
                _array.push(this.cartaServices.carta_dish_prod_array_tmp.length + 1); //Order
                _array.push('combo');
                if (element.title_es != undefined && element.title_es != '') {
                    _array.push(element.title_es);
                } else {
                    _array.push(this.globals.returnLangCartaMenuCombo(element));
                }
                if (element.title_ca != undefined && element.title_ca != '') {
                    _array.push(element.title_ca);
                } else {
                    _array.push(this.globals.returnLangCartaMenuCombo(element));
                }
                if (element.title_en != undefined && element.title_en != '') {
                    _array.push(element.title_en);
                } else {
                    _array.push(this.globals.returnLangCartaMenuCombo(element));
                }
                if (element.title_de != undefined && element.title_de != '') {
                    _array.push(element.title_de);
                } else {
                    _array.push(this.globals.returnLangCartaMenuCombo(element));
                }
                if (element.title_fr != undefined && element.title_fr != '') {
                    _array.push(element.title_fr);
                } else {
                    _array.push(this.globals.returnLangCartaMenuCombo(element));
                }
                if (element.title_it != undefined && element.title_it != '') {
                    _array.push(element.title_it);
                } else {
                    _array.push(this.globals.returnLangCartaMenuCombo(element));
                }
                if (element.allergens != undefined) {
                    _array.push(element.allergens);
                } else {
                    _array.push([]);
                }
                _array.push(element.price);
                _array.push('');
                _array.push('');
                _array.push(element.menu_cost);
                if (element.image != undefined) {
                    _array.push(element.image);
                } else {
                    _array.push('');
                }
                if (element.subtitle_es != undefined && element.subtitle_es != '') {
                    _array.push(element.subtitle_es);
                } else {
                    _array.push(this.globals.returnSubtitleLangCartaMenuCombo(element));
                }
                if (element.subtitle_ca != undefined && element.subtitle_ca != '') {
                    _array.push(element.subtitle_ca);
                } else {
                    _array.push(this.globals.returnSubtitleLangCartaMenuCombo(element));
                }
                if (element.subtitle_en != undefined && element.subtitle_en != '') {
                    _array.push(element.subtitle_en);
                } else {
                    _array.push(this.globals.returnSubtitleLangCartaMenuCombo(element));
                }
                if (element.subtitle_de != undefined && element.subtitle_de != '') {
                    _array.push(element.subtitle_de);
                } else {
                    _array.push(this.globals.returnSubtitleLangCartaMenuCombo(element));
                }
                if (element.subtitle_fr != undefined && element.subtitle_fr != '') {
                    _array.push(element.subtitle_fr);
                } else {
                    _array.push(this.globals.returnSubtitleLangCartaMenuCombo(element));
                }
                if (element.subtitle_it != undefined && element.subtitle_it != '') {
                    _array.push(element.subtitle_it);
                } else {
                    _array.push(this.globals.returnSubtitleLangCartaMenuCombo(element));
                }
                _array.push([]);
                if (element.price_takeaway != undefined) {
                    _array.push(element.price_takeaway);
                } else {
                    _array.push('');
                }
                if (element.tk_active) {
                    _array.push(true);
                } else {
                    _array.push(false);
                }
                if (element.featured) {
                    _array.push(true);
                } else {
                    _array.push(false);
                }
                if (element.tk_pickup_day) {
                    _array.push(element.tk_pickup_day);
                } else {
                    _array.push('');
                }
                if (element.tax) {
                    _array.push(element.tax);
                } else {
                    _array.push(10);
                }

                let toast = this.toastCtrl.create({
                    message: this.translate.instant('menu-create-select-type-combo') + ' ' + this.globals.nameLangSelectMenu(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            }
            this.cartaServices.carta_dish_prod_array_tmp.push(_array);
            this.cartaServices.carta_dish_prod_array_tmp = [...this.cartaServices.carta_dish_prod_array_tmp];
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-elemento-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.cartaServices.carta_dish_prod_array_tmp.length; i++) {
            var obj = this.cartaServices.carta_dish_prod_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }
    nextPage() {
        if (this.cartaServices.page_active_paginator < this.cartaServices.pagesDishesProducts.length) {
            this.cartaServices.page_active_paginator += 1
        }
        this.cartaServices.getListDishesProductsMinMax();
        document.getElementById('scroll_carta_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    previusPage() {
        if (this.cartaServices.page_active_paginator > 1) {
            this.cartaServices.page_active_paginator -= 1;
        }
        this.cartaServices.getListDishesProductsMinMax();
        document.getElementById('scroll_carta_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    activePage(number) {
        this.cartaServices.page_active_paginator = number;
        this.cartaServices.getListDishesProductsMinMax();
        document.getElementById('scroll_carta_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }
    createDish() {
        //open create dish
        let profileModal = this.modalCtrl.create(CompCreateDishPage, {
            origin: 'carta'
        });
        profileModal.present();
    }
}


// WEBPACK FOOTER //
// ./src/pages/carta/carta-create/carta-create-dish-prod-select/carta-partial-dish-prod-select/carta-partial-dish-prod-select.ts